module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_j_albino.e2a030bf.png";